<div class="d-flex small-upper-space">
  <div>
    <div>
      <span class="strong">
        {{ getProductType(product.type, product.otherProductName) }}
      </span>

      <span *ngIf="multipleProducts" class="product-number">
        #{{ index + 1 }}
      </span>
    </div>

    <div *ngIf="product.otherProductMaterial != null" class="small-upper-space">
      <span class="preserve-line-break">
        {{ product.otherProductMaterial }}
      </span>
    </div>

    <div>
      <span class="font-weight-bold">Afmetingen: </span>
      {{ product.height ? product.height : '0' }} cm h x
      {{ product.width ? product.width : '0' }} cm b
    </div>
  </div>

  <div *ngIf="product.productAssets != null" class="flexer large-left-space">
    <div class="d-flex images">
      <div *ngFor="let item of product.productAssets | archivefilter">
        <div
          *ngIf="item?.formSection === 'execution'"
          class="loadedImg align-middle"
          matTooltip="{{ item?.asset?.name }}"
        >
          <div class="d-flex box click-link max-summary-width">
            <a
              download="{{ item.asset.name }}"
              href="/api/assets/{{ item.asset.uuid }}"
              style="margin-right: 7px"
              class="d-flex box"
            >
              <div class="filename">{{ shortenName(item?.asset?.name) }}</div>

              <a>
                <mat-icon aria-hidden="false" aria-label="remove">
                  cloud_download
                </mat-icon>
              </a>
            </a>
          </div>

          <a
            class="click-link"
            href="/api/assets/{{ item.asset.uuid }}"
            *ngIf="isImage(item.asset)"
            data-lightbox="product"
          >
            <img
              *ngIf="isImage(item.asset)"
              class="max-summary-width max-summary-height"
              src="/api/assets/{{ item.asset.uuid }}"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
